import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DirectLoginState, getDirectLogin } from '@uxdf/direct-shared-lib';

@Injectable()
export class RegistrationGuard implements CanActivate {
  directLogin$: Observable<DirectLoginState>;

  constructor(private readonly store: Store<any>, private readonly router: Router) {}

  canActivate(): Observable<boolean> {
    this.directLogin$ = this.store.pipe(select(getDirectLogin));

    return this.directLogin$.pipe(
      take(1),
      map(directLogin => {
        if (directLogin.loginStatus === 'REGISTRATION' && +directLogin.code === 404) {
          return true;
        } else {
          const email = window.location.hash.substr(2).split('/')[1];
          if (email !== undefined) {
            sessionStorage.setItem('email_for_registration', email);
          }

          console.warn('[REGISTRATION GUARD]');
          this.router.navigate(['login']);
          return false;
        }
      })
    );
  }
}
